export interface InspectionOfflineCheckTestRequest {
  inspectionId: number
  fileName: string
}

export function InspectionOfflineCheckTestRequestToJSON(
  value: InspectionOfflineCheckTestRequest
): any {
  return {
    inspection_id: value.inspectionId,
    file_name: value.fileName
  }
}
